import { CloseOutlined } from '@ant-design/icons';
import { default as Skeleton } from 'antd/es/skeleton';
import { useState } from 'react';

import { useGetCustomerUsersUserId } from 'api';

import { useOrganisationId } from 'hooks/context';

import { TertiaryButton } from '@atoms/buttons/TertiaryButton';

import { userManagementDetailsT as translations } from './translations';
import { UserDetailsEdit } from './UserDetailsEdit';
import { UserDetailsShow } from './UserDetailsShow';

import {
  USER_DETAILS_CLOSE_BUTTON_TEST_ID,
  USER_DETAILS_TEST_ID
} from '../constants';

type Props = {
  onClose: VoidFunction;
  userId: number;
};

export const UserManagementDetails = ({ onClose, userId }: Props) => {
  const organisationId = useOrganisationId<number>();
  const [isEdit, setIsEdit] = useState(false);

  const {
    data: { data: userData } = {},
    isLoading,
    isSuccess,
    isError,
    refetch
  } = useGetCustomerUsersUserId(organisationId, userId);

  const onEditClick = () => {
    setIsEdit(true);
  };

  const onFormClose = () => {
    setIsEdit(false);
  };
  const onFormSuccess = () => {
    refetch();
    setIsEdit(false);
  };

  return (
    <div
      style={{
        flex: 0.25,
        borderRadius: '.75rem'
      }}
      data-testid={USER_DETAILS_TEST_ID}
      className="cool-shadow overflow-y-auto"
    >
      <div className="relative flex items-center rounded-t-xl bg-white px-6 pt-3.5 text-xl font-medium">
        <span>{translations.title}</span>
        <TertiaryButton
          data-testid={USER_DETAILS_CLOSE_BUTTON_TEST_ID}
          className="ml-auto"
          icon={<CloseOutlined />}
          onClick={onClose}
        />
      </div>
      <div className="flex flex-col bg-white px-6 pb-4">
        {isLoading && <Skeleton />}
        {userData && isSuccess && (
          <>
            {!isEdit ? (
              <UserDetailsShow data={userData} onEditClick={onEditClick} />
            ) : (
              <UserDetailsEdit
                data={userData}
                onCancelClick={onFormClose}
                onSuccess={onFormSuccess}
              />
            )}
          </>
        )}
        {isError && (
          <div className="flex h-full items-center justify-center">
            {translations.errorMessage}
          </div>
        )}
      </div>
    </div>
  );
};
